import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { app } from "../firebase/app";
import { Id } from "../types";

const storage = getStorage(app);

type OnProgress = (percent: number) => void;

export function upload(
  data: Blob,
  id: Id,
  onProgress: OnProgress,
): PromiseLike<string> {
  const storageRef = ref(storage, `/user-images/${id}`);

  const task = uploadBytesResumable(storageRef, data);
  task.on("state_changed", function (snapshot) {
    const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    onProgress(percent);
  });

  return new Promise((resolve, reject) => {
    task.then(() => {
      getDownloadURL(storageRef).then(resolve);
    }, reject);
  });
}
